module.exports = __webpack_public_path__ + "img/manage24.7d17786.svg";